import { type ReactNode } from 'react';

import { useSessionFeatures } from '@/entities/auth';

interface FeatureDisplayGuardProps {
    requiredFeature: string;
    children: ReactNode;
}

// This component decides whether to display its children based on the presence of a required feature.
export function FeatureDisplayGuard({
    requiredFeature,
    children,
}: FeatureDisplayGuardProps) {
    const sessionFeatures = useSessionFeatures();

    const hasAccess = sessionFeatures.includes(requiredFeature);

    if (!hasAccess) {
        return null;
    }

    return children;
}
